/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { useHttpServiceStore } from 'dxpConsoleCore-mf/State';
import { HttpRxAdapter } from '../../Services/Http/Adapters/Rx/HttpRx.adapter';
import { HttpService } from '../../Services/Http/Http.service';

/**
 * Get the HTTP Service.
 */
export const getHttpService = (): HttpService => {
  const { updateHttpService } = useHttpServiceStore.getState();
  const { httpService }: { httpService: HttpService | null } = useHttpServiceStore.getState();

  if (!httpService) {
    const httpAdapter = new HttpRxAdapter({});
    const newHttpService = new HttpService({ httpAdapter });

    updateHttpService(newHttpService);

    return newHttpService;
  }

  return httpService;
};
